import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';
import {
  ROUTES_EPM,
  ROUTES_ENCOMPASS,
  ROUTES_EYEFINITY,
  ROUTES_PE_EMPLOYEE,
} from '@share/constants';
import { NavGuard } from './core/nav-guard/nav.guard';
import { DashboardErrorComponent } from './data-services/dashboard-error/dashboard-error.component';
import { BlankComponent } from './data-services/blank/blank.component';

const routes: Routes = [
  {
    path: ROUTES_EYEFINITY,
    canActivate: [],
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./eyefinity-dashboard/eyefinity-dashboard.module').then(
            (m) => m.EyefinityDashboardModule,
          ),
      },
    ],
  },
  {
    path: ROUTES_EPM,
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: ROUTES_ENCOMPASS,
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: ROUTES_PE_EMPLOYEE,
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: '**',
    canActivate: [NavGuard],
    component: DashboardErrorComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
  providers: [],
  declarations: [],
})
export class AppRoutingModule {}
